import reducer, { LoadingState } from './reducers';
import * as loadingOperations from './operations';

export { LoadingState, loadingOperations };
export default reducer;




// WEBPACK FOOTER //
// ./src/redux/modules/loading/index.ts